import { Link } from "react-router-dom";

export default function HomeGrid(props) {
    const gridContent = (
        <div className="grid">
            <div className={`grid-icon d-flex justify-items-center`}>
                <div className={`ion_box ${props.color} ${props.class}`}>
                    <i className={props.icon}></i>
                </div>
                {props.dropdown && (
                    <span className="home-grid-dropdown-badge">
                        <i className="fa-solid fa-chevron-down" />
                    </span>
                )}
            </div>
            <div className="grid-text">
                <h6 className="fw-bold">{props.title}</h6>
            </div>
            <div className="grid-number">
                <h6 className={props.valueColor}>{props.value}</h6>
            </div>
        </div>
    );

    if (props.dropdown) {
        return (
            <div className={`${props.divClass ?? 'col-md-1 text-center col-4'}`}>
                <div className="dropdown home-grid-dropdown w-100">
                    <div
                        className="home-grid-dropdown-toggle"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {gridContent}
                    </div>
                    <ul className="dropdown-menu home-grid-dropdown-menu shadow-sm">
                        <li className="home-grid-dropdown-header">
                            <i className={props.dropdown.icon} />
                            <span>{props.title}</span>
                        </li>
                        <li><hr className="dropdown-divider my-1" /></li>
                        {props.dropdown.items.map((item, index) => (
                            <li key={index}>
                                <Link
                                    className="dropdown-item home-grid-dropdown-item d-flex justify-content-between align-items-center"
                                    to={item.route}
                                >
                                    <span className="d-flex align-items-center gap-2">
                                        <i className={`${props.dropdown.icon} home-grid-dropdown-item-icon`} />
                                        {item.label}
                                    </span>
                                    <span className="badge bg-danger">{item.count ?? 0}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <div className={`${props.divClass ?? 'col-md-1 text-center col-4'}`}>
            <Link to={props.route}>{gridContent}</Link>
        </div>
    );
}
